package com.advaita.cloud.drive.shared

import kotlinx.serialization.Serializable

@Serializable
enum class UploadSessionStatus { INITIATED, COMPLETED, ABORTED }
